import { Selection } from '@susu/headless-commerce/features/configurator/domain/Selection/Selection'
import type { SelectionDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Selection/SelectionDataAccessObject'

export class SelectionEncoder {
  static encode(instance: Selection) {
    return {
      default: instance.default.value,
      recommended: instance.recommended.value,
      current: instance.current.value,
      previous: instance.previous.value,
    }
  }

  static decode(properties: SelectionDataAccessObject) {
    const instance = new Selection(
      properties.default,
      properties.recommended,
      properties.current,
      properties.previous,
    )
    return instance
  }
}
